module.exports = __webpack_public_path__ + "static/media/logo.2475040a.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-form-builder/es/Header/logo.png
// module id = 700
// module chunks = 0